/**
 * Text-zu-Bild Studio: Raum-Mockup + Lupe (Display-Asset, kein Druckmaster).
 */
(function () {
  'use strict';

  var RATIO = { '1:1': '1 / 1', '3:2': '3 / 2', '2:3': '2 / 3', '1:2': '1 / 2', '2:1': '2 / 1' };
  /* Querkant 3:2 und Hochkant 2:3 = dasselbe Rechteck, nur gedreht, gleicher Mittelpunkt.
     Anzeige immer in der großen Größe – S/M/L/XL ändert die Bestellung, nicht die Vorschau. */
  var WALL = { cx: 50, cy: 34, long: 52 };
  /* MerchOne-Kissen auf dem Sessel, 1:1-Szene. Slot = Druckfläche auf dem Kissen. */
  var PILLOW_SLOT = { top: 24.2, left: 23.4, width: 53.2, height: 52.4 };
  /* Sporthandtuch, 2:1-Druckfläche auf dem gefalteten Tuch. 1:2 nutzt dieselbe Fläche, Motiv gedreht. */
  var TOWEL_SLOT = { top: 38.5, left: 12, width: 76, height: 38 };
  /* Premium Mug, 70×70 mm Hochformat. Links = Henkel rechts, Rechts = Henkel links. */
  var MUG_SLOT_LEFT = { top: 33.1, left: 31.2, width: 35.6, height: 35.6 };
  var MUG_SLOT_RIGHT = { top: 33.1, left: 33.2, width: 35.6, height: 35.6 };

  function slotsFor(wall) {
    var w = wall || WALL;
    var short = w.long * 2 / 3;
    var mid = (w.long + short) / 2;
    return {
      '1:1': { top: w.cy - mid / 2, left: w.cx - mid / 2, width: mid, height: mid },
      '3:2': { top: w.cy - short / 2, left: w.cx - w.long / 2, width: w.long, height: short },
      '2:3': { top: w.cy - w.long / 2, left: w.cx - short / 2, width: short, height: w.long },
      '2:1': { top: w.cy - (w.long / 2) / 2, left: w.cx - w.long / 2, width: w.long, height: w.long / 2 },
      '1:2': { top: w.cy - w.long / 2, left: w.cx - (w.long / 2) / 2, width: w.long / 2, height: w.long }
    };
  }

  function applySlot(roomEl, slot) {
    roomEl.style.setProperty('--slot-top', slot.top + '%');
    roomEl.style.setProperty('--slot-left', slot.left + '%');
    roomEl.style.setProperty('--slot-width', slot.width + '%');
    roomEl.style.setProperty('--slot-height', slot.height + '%');
    roomEl.style.setProperty('--slot-rotate', '0deg');
  }

  function setScene(roomEl, artEl, state) {
    if (!roomEl || !artEl) return;
    var type = (state && state.type) || 'canvas';
    var format = (state && state.format) || '1:1';
    var wall = (state && state.wallBox) || WALL;
    var photo = roomEl.querySelector('.mp-room__photo');
    var bg = (state && state.bg) || (type === 'pillow'
      ? roomEl.getAttribute('data-bg-pillow')
      : type === 'towel'
        ? roomEl.getAttribute('data-bg-towel')
        : type === 'mug'
          ? roomEl.getAttribute('data-bg-mug')
          : roomEl.getAttribute('data-bg-wall'));
    var token = (roomEl._sceneTok = (roomEl._sceneTok || 0) + 1);
    var apply = function () {
      if (token !== roomEl._sceneTok) return;
      roomEl.dataset.scene = type === 'pillow' ? 'pillow' : (type === 'towel' ? 'towel' : (type === 'mug' ? 'mug' : 'wall'));
      roomEl.dataset.product = type;
      roomEl.dataset.format = format;
      artEl.style.setProperty('--art-ratio', RATIO[format] || '1 / 1');
      roomEl.style.setProperty('--art-ratio', RATIO[format] || '1 / 1');
      artEl.dataset.product = type;
      if (state && state.slot) {
        applySlot(roomEl, state.slot);
      } else if (type === 'pillow') {
        applySlot(roomEl, PILLOW_SLOT);
      } else if (type === 'towel') {
        applySlot(roomEl, TOWEL_SLOT);
      } else if (type === 'mug') {
        applySlot(roomEl, state && state.side === 'left' ? MUG_SLOT_LEFT : MUG_SLOT_RIGHT);
      } else {
        applySlot(roomEl, slotsFor(wall)[format] || slotsFor(wall)['1:1']);
      }
      if (photo && bg && photo.getAttribute('src') !== bg) photo.src = bg;
    };
    if (!bg || !photo || photo.getAttribute('src') === bg) {
      apply();
      return;
    }
    var probe = new Image();
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      apply();
    };
    probe.onload = finish;
    probe.onerror = finish;
    probe.src = bg;
    if (probe.complete && probe.naturalWidth) finish();
  }

  function setupLoupe(artEl, imgEl, loupeEl) {
    if (!artEl || !imgEl || !loupeEl) return function () {};

    var ZOOM = 2.6;
    var active = false;
    var home = loupeEl.parentNode;

    function place(clientX, clientY) {
      var r = artEl.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = (clientX - r.left) / r.width;
      var y = (clientY - r.top) / r.height;
      if (x < -0.02 || x > 1.02 || y < -0.02 || y > 1.02) {
        hide();
        return;
      }
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));

      var L = loupeEl.offsetWidth || 160;
      var nw = imgEl.naturalWidth || r.width;
      var nh = imgEl.naturalHeight || r.height;
      var cover = Math.max(r.width / nw, r.height / nh);
      var dispW = nw * cover;
      var dispH = nh * cover;
      var fx = ((dispW - r.width) / 2 + x * r.width) / dispW;
      var fy = ((dispH - r.height) / 2 + y * r.height) / dispH;
      var bgW = dispW * ZOOM;
      var bgH = dispH * ZOOM;

      if (loupeEl.parentNode !== document.body) document.body.appendChild(loupeEl);
      loupeEl.hidden = false;
      loupeEl.style.position = 'fixed';
      loupeEl.style.left = clientX + 'px';
      loupeEl.style.top = clientY + 'px';
      loupeEl.style.zIndex = '9999';
      loupeEl.style.backgroundImage = 'url("' + (imgEl.currentSrc || imgEl.src) + '")';
      loupeEl.style.backgroundRepeat = 'no-repeat';
      loupeEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      loupeEl.style.backgroundPosition = (L / 2 - fx * bgW) + 'px ' + (L / 2 - fy * bgH) + 'px';
    }

    function point(e) {
      return e.touches ? e.touches[0] : e;
    }

    function show(e) {
      if (!imgEl.currentSrc && !imgEl.src) return;
      active = true;
      artEl.classList.add('is-loupe');
      var p = point(e);
      place(p.clientX, p.clientY);
    }

    function move(e) {
      if (!active && e.pointerType === 'mouse') show(e);
      if (!active) return;
      if (e.pointerType === 'touch') e.preventDefault();
      var p = point(e);
      place(p.clientX, p.clientY);
    }

    function hide() {
      active = false;
      loupeEl.hidden = true;
      artEl.classList.remove('is-loupe');
    }

    function onDown(e) {
      if (e.pointerType === 'touch' || e.pointerType === 'pen') {
        try { artEl.setPointerCapture(e.pointerId); } catch (_) {}
        show(e);
      }
    }

    function onUp(e) {
      if (e.pointerType === 'touch' || e.pointerType === 'pen') hide();
    }

    artEl.addEventListener('pointerenter', show);
    artEl.addEventListener('pointermove', move);
    artEl.addEventListener('pointerleave', hide);
    artEl.addEventListener('pointerdown', onDown);
    artEl.addEventListener('pointerup', onUp);
    artEl.addEventListener('pointercancel', hide);

    return function destroy() {
      hide();
      artEl.removeEventListener('pointerenter', show);
      artEl.removeEventListener('pointermove', move);
      artEl.removeEventListener('pointerleave', hide);
      artEl.removeEventListener('pointerdown', onDown);
      artEl.removeEventListener('pointerup', onUp);
      artEl.removeEventListener('pointercancel', hide);
      if (home && loupeEl.parentNode !== home) home.appendChild(loupeEl);
    };
  }

  window.MaipicStudio = {
    setupLoupe: setupLoupe,
    setScene: setScene,
    slotsFor: slotsFor,
    pillowSlot: PILLOW_SLOT,
    towelSlot: TOWEL_SLOT,
    mugSlotLeft: MUG_SLOT_LEFT,
    mugSlotRight: MUG_SLOT_RIGHT
  };
})();
